import { Grid2 as Grid, Typography } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SearchResults } from 'types/Search';
import { SearchViewProps } from '../SearchViewProps';
import { getProductPictureUrl } from '../getProductPicture';
import { LoadingIndicator } from '../shared/LoadingIndicator';
import { SearchCard } from './SearchCard';
import { SCROLLABLE_DIV_ID } from 'components/constants/Constants';

type SearchCardViewProps = {
  searchResults: SearchResults;
  onLoadMore: () => void;
} & SearchViewProps;

export const SearchCardView: React.FC<SearchCardViewProps> = ({
  searchResults,
  ...props
}) => {
  return searchResults.results.length > 0 ? (
    <InfiniteScroll
      scrollableTarget={SCROLLABLE_DIV_ID}
      dataLength={searchResults.results.length}
      next={props.onLoadMore}
      hasMore={searchResults.total > searchResults.results.length + 1}
      loader={<LoadingIndicator />}
      scrollThreshold={0.8}
      style={{ overflow: 'hidden', marginTop: '24px' }}
    >
      <Grid container spacing={3} size={12}>
        {searchResults.results.map(({ document }, key) => (
          <SearchCard
            extraProp={key}
            productKey={document.old_key}
            key={document.key}
            productType={document.type}
            name={document.name}
            description={
              document.event?.product_private_attributes?.data?.tagline
            }
            image={getProductPictureUrl(document)}
            selectionModeEnabled={props.selectionModeEnabled}
            canSelectMore={props.canSelectMore}
            selected={props.isSelected(document.id)}
            onSelectedChange={selected =>
              props.onSelectedChange(document, selected)
            }
            bookmarked={document.bookmarked ?? false}
            onBookmarkChange={bookmarked =>
              props.onBookmarkChange?.(document, bookmarked)
            }
          />
        ))}
      </Grid>
    </InfiniteScroll>
  ) : (
    <Typography variant="h6" align="center">
      No matching {searchResults.search?.target.toLowerCase()} found.
    </Typography>
  );
};
